import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import de from 'vuetify/src/locale/de'
import en from 'vuetify/src/locale/en'
import nl from 'vuetify/src/locale/nl'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#e50056',
        secondary: '#50e3c2',
        accent: '#82B1FF',
        error: '#e10000',
        info: '#ffffff',
        success: '#1f883d',
        warning: '#f5a623'
      }
    }
  },
  lang: {
    locales: { de, nl, en },
    current: process.env.VUE_APP_I18N_LOCALE || 'nl'
  }
})
